export default "__VITE_ASSET__DAdWJLZs__"